export default "__VITE_ASSET__BBZahVsg__"